import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/'
import { i18n } from './i18n'
import './core/use'
import './permission'
import './components/global.less'

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
